<template>
  <b-card class="bg-white rounded-xl px-2">
    <AddBannerPopup :isOpen="isPopupOpen" @close="togglePopup" />
    <div class="flex justify-between items-center">
      <div>
        <h2 class="text-2xl font-semibold">List of Homepage Banner</h2>
      </div>

      <base-button
        outline
        class="px-6 py-1 mx-1"
        type="primary"
        @click="handleAdd"
      >
        <span class="btn-inner--text flex justify-between items-center"
          ><feather-icon icon="PlusIcon" class="cust-HW"></feather-icon>Add
          Banner</span
        >
      </base-button>
    </div>
    <BannerTable />
  </b-card>
</template>

<script>
import BannerTable from "./components/bannerTable.vue";
import AddBannerPopup from "./components/AddBannerPopup.vue";

export default {
  data() {
    return {
      isPopupOpen: false,
    };
  },
  components: {
    BannerTable,
    AddBannerPopup,
  },
  methods: {
    handleAdd() {
      this.$router.push({ name: "addHomePageBanner" });
    },
    async togglePopup(val = false) {
      this.isPopupOpen = val;
    },
  },
};
</script>
<style>
.txt-color {
  color: #4f0a4b;
}
</style>
